// Libraries
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */

/**
 * @class VotingFormController
 * @extends Controller
 * @description Handles the submission of the voting form
 */
class VotingFormController extends Controller {
    static targets = [
        'fields',
        'confirmation',
        'email',
        'form',
        'sites',
        'validation',
        'radio',
    ];
    static values = { value: String };

    /**
     * @method connect
     * @description Hide confirmation elements.
     *
     * @return {void}
     */
    connect() {
        if (this.hasConfirmationTarget) {
            this.confirmationTarget.style.display = 'none';
        }

        if (this.hasValidationTarget) {
            this.validationTarget.style.display = 'none';
        }
    }

    /**
     * @method preSubmitVote
     * @description Validate the email input and display confirmation.
     *
     * @return {void}
     */
    preSubmitVote() {
        let html = '';

        if (
            this.hasEmailTarget &&
            this.hasValidationTarget &&
            !this.emailTarget.checkValidity()
        ) {
            this.validationTarget.style.display = 'block';
            return;
        }

        this.radioTargets.forEach((radio) => {
            if (radio.checked) {
                const closestElement = radio.closest('.element');
                const h3Text = closestElement.querySelector('h3').innerHTML;
                const spanText = radio
                    .closest('div')
                    .querySelector('span').innerHTML;

                html += `<div><b>${h3Text}</b> - ${spanText}</div>`;
            }
        });

        this.sitesTarget.innerHTML = html;
        this.fieldsTarget.style.display = 'none';
        this.confirmationTarget.style.display = 'block';
    }

    /**
     * @method cancelVote
     * @description Cancel the submission and re-display the form.
     *
     * @return {void}
     */
    cancelVote() {
        this.confirmationTarget.style.display = 'none';
        this.fieldsTarget.style.display = 'block';
        this.sitesTarget.innerHTML = '';
    }
}

// Exports
export default VotingFormController;
